module.exports = __webpack_public_path__ + "img/softball1@2.618e6d40.jpg";